import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyAm07L6IGUcYLv2SDg1YBsi85b5fZ8YbIs',
  authDomain: 'hangout-c1937.firebaseapp.com',
  projectId: 'hangout-c1937',
  storageBucket: 'hangout-c1937.firebasestorage.app',
  messagingSenderId: '917202614397',
  appId: '1:917202614397:web:4cbca409a5c90b4e61d914',
  measurementId: 'G-QXJVNCTF36',
};

const app = initializeApp(firebaseConfig);

let analyticsInstance = null;

const analyticsReady = isSupported().then((supported) => {
  if (supported) {
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
});

const getAnalyticsInstance = () => analyticsReady;

export { app, analyticsInstance as analytics, getAnalyticsInstance };
